( ( $ ) => {
	"use strict";
	$( 'a[data-scrollto]' ).on( 'click', function ( event ) {
		scrollToEl( $( this ).attr( 'data-scrollto' ), event );
	} );

	$( 'a[href^="#"]' ).on( 'click', ':not(a[href="#content"])', function ( event ) {
		const $btn = $( this );
		if ( $btn.attr( 'data-toggle' ) || $btn.attr( 'data-scrollto' ) || $btn.hasClass( 'ui-tabs-anchor' ) || $btn.parent().hasClass( 'more' ) || $btn.parent().hasClass( 'less' ) ) {
			return;
		}
		scrollToEl( $btn.attr( 'href' ), event );
	} );

	function scrollToEl( href, event ) {
		console.log( 'scrollto', href, event );
		let $target = $( href );
		if ( $target.length ) {
			if ( event ) {
				event.preventDefault();
			}


			let shift = $( 'header.site-header .menu-wrap' ).height();

			// lets open accordions if it's not opened.
			if ( $target.hasClass( 'collapse' ) ) {
				// let's open it.
				$target.collapse( 'show' );
				const $btn = $target.siblings( `[data-toggle="collapse"][href="#${ $target.attr( 'id' ) }"]` );
				if ( $btn.length ) {
					$target = $btn;
				}
			}

			$( 'html, body' ).animate( {
				scrollTop: $target.offset().top - shift
			}, 1000 );

			if ( window.history ) {
				window.history.pushState( null, '', href );
			}
		}
	}

	if ( window.location.hash && window.location.hash !== '#' && window.location.hash.indexOf( '#' ) === 0 ) {
		scrollToEl( window.location.hash );
	}

	if ( "onhashchange" in window ) {
		$( window ).on( 'hashchange', () => {
			if ( window.location.hash && window.location.hash !== '#' && window.location.hash.indexOf( '#' ) === 0 ) {
				scrollToEl( window.location.hash );
			}
		} );
	}

} )( jQuery )